// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rules-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; /* Centers the content vertically if needed */
  padding: 20px;
}

.club-headers {
  color: #292929;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 800;
  line-height: 170%;
  letter-spacing: -0.38px;
  position: relative;
  display: inline-block;
}

@media (min-width: 600px) {
  .club-headers {
    font-size: 32px; /* For screens wider than 600px */
  }
}
.rules-headers {
  margin-top: 15px;
  color: #292929;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 170%;
  letter-spacing: -0.38px;
  position: relative;
  display: inline-block;
}

@media (min-width: 600px) {
  .rules-headers {
    margin-top: 20px;
    font-size: 32px; /* For screens wider than 600px */
  }
}
.rules-headers::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: black;
  bottom: -2px;
  left: 0;
}

.rules-text {
  margin-top: 35px;
  margin-bottom: 35px;
  color: #292929;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 170%;
  letter-spacing: -0.304px;
}

@media (min-width: 600px) {
  .rules-text {
    font-size: 24px; /* For screens wider than 600px */
  }
}
.rules-indent {
  text-align: left; /* Ensure the span text alignment is left */
  margin-left: 1em; /* Indent the text */
}

.actual-rules-container {
  display: flex;
  justify-content: flex-start; /* Change to flex-start for left alignment */
  align-items: flex-start;
  flex-direction: column;
}

.actual-rules-text {
  color: #292929;
  text-align: left; /* Change to flex-start for left alignment */
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 170%;
  letter-spacing: -0.304px;
}

@media (min-width: 600px) {
  .actual-rules-text {
    font-size: 24px; /* For screens wider than 600px */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BirdiePool/BirdieRules/BirdieRules.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA,EAAA,6CAAA;EACA,aAAA;AACJ;;AAEE;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AACJ;;AACE;EACE;IACE,eAAA,EAAA,iCAAA;EAEJ;AACF;AACE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AACJ;;AAGE;EACE;IACE,gBAAA;IACA,eAAA,EAAA,iCAAA;EAAJ;AACF;AAGE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,OAAA;AADJ;;AAIE;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AADJ;;AAIE;EACE;IACE,eAAA,EAAA,iCAAA;EADJ;AACF;AAIE;EACE,gBAAA,EAAA,2CAAA;EACA,gBAAA,EAAA,oBAAA;AAFJ;;AAKE;EACE,aAAA;EACA,2BAAA,EAAA,4CAAA;EACA,uBAAA;EACA,sBAAA;AAFJ;;AAKE;EACE,cAAA;EACA,gBAAA,EAAA,4CAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAFJ;;AAKE;EACE;IACE,eAAA,EAAA,iCAAA;EAFJ;AACF","sourcesContent":[".rules-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column; /* Centers the content vertically if needed */\n    padding: 20px;\n  }\n\n  .club-headers {\n    color: #292929;\n    text-align: center;\n    font-family: 'Inter', sans-serif;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 170%;\n    letter-spacing: -0.38px;\n    position: relative;\n    display: inline-block; // Make the span cover only the width of the text\n  }\n  @media (min-width: 600px) {\n    .club-headers {\n      font-size: 32px; /* For screens wider than 600px */\n    }\n  }\n  \n  .rules-headers {\n    margin-top: 15px;\n    color: #292929;\n    text-align: center;\n    font-family: 'Inter', sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 170%;\n    letter-spacing: -0.38px;\n    position: relative;\n    display: inline-block; // Make the span cover only the width of the text\n  }\n  \n\n  @media (min-width: 600px) {\n    .rules-headers {\n      margin-top: 20px;\n      font-size: 32px; /* For screens wider than 600px */\n    }\n  }\n\n  .rules-headers::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 3px;\n    background-color: black;\n    bottom: -2px;\n    left: 0;\n  }\n\n  .rules-text {\n    margin-top: 35px;\n    margin-bottom: 35px;\n    color: #292929;\n    text-align: center;\n    font-family: 'Inter', sans-serif;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 170%;\n    letter-spacing: -0.304px;\n  }\n\n  @media (min-width: 600px) {\n    .rules-text {\n      font-size: 24px; /* For screens wider than 600px */\n    }\n  }\n  \n  .rules-indent {\n    text-align: left; /* Ensure the span text alignment is left */\n    margin-left: 1em; /* Indent the text */\n  }\n\n  .actual-rules-container {\n    display: flex;\n    justify-content: flex-start;  /* Change to flex-start for left alignment */\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .actual-rules-text {\n    color: #292929;\n    text-align: left; /* Change to flex-start for left alignment */\n    font-family: 'Inter', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 170%;\n    letter-spacing: -0.304px;\n  }\n\n  @media (min-width: 600px) {\n    .actual-rules-text {\n      font-size: 24px; /* For screens wider than 600px */\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
